import {
  Business as BussinesIcon,
  LocalFireDepartment as LocalFireDepartmentIcon,
  Public as PublicIcon,
} from '@mui/icons-material';

import { SmartReportTypeEnum } from '@/admins/SmartReports/types';
import { SmartReportStatusEnum } from '@/types/GraphqlSchema';

export const REPORT_STATUS_COLORS = {
  [SmartReportStatusEnum.Published]: 'success',
  [SmartReportStatusEnum.Draft]: 'warning',
  [SmartReportStatusEnum.Archived]: 'default',
};

export const REPORT_TYPE_ICONS = {
  [SmartReportTypeEnum.Country]: <PublicIcon />,
  [SmartReportTypeEnum.Asset]: <LocalFireDepartmentIcon />,
  [SmartReportTypeEnum.Corporate]: <BussinesIcon />,
};
